import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "./WorklistCardComponent.css";
import { FaChevronRight } from "react-icons/fa";
import moment from "moment";
import { Badge } from "primereact/badge";
import CommentComponent from "../Input/CommentComponent";
import { IUserModel } from "../../IRequestModel/IUserModel";
import { useTranslation } from "react-i18next";
import { BadgeNotificate } from "../AntdControlComponent/BadgeNotificateComponent/BadgeNotificate";
import { Space } from "antd";
import { motion } from "framer-motion";
import useMasterSetting from "../../hooks/useMasterSetting";
import { GetApprovalsByMemoIDs } from "../../Services/LineApprovalsService";
import { useUserContext } from "../../Context/UserContext";
import { v4 as uuidv4 } from "uuid";

interface Props {
  dataWorklist?: any;
  data: any;
  setContent: (
    memoId: number,
    status: string,
    index: number,
    requestor: IUserModel
  ) => void;
  index: number;
  onUpdate: (
    type: any,
    memoid: any,
    comment?: any,
    waiting_for?: string,
    waiting_for_id?: number
  ) => void;
  taskGourp: any;
  currentMemoId: number;
  toggleDetail: any;
  setToggleDetail: any;
  setOnDetailLoading: any;
}

export const WorklistCardComponent = (props: Props) => {
  const [data, setData] = useState<any>(props.data || {});
  const [dataUrl, setDataUrl] = useState<string>("");
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isCommentActive, setIsCommentActive] = useState(false);
  const { masterSetting } = useMasterSetting();
  const [lineApproval, setLineApproval] = useState<any[]>([]);
  const [user] = useUserContext();
  const [url, setUrl] = useState<string | null | any>("");

  useEffect(() => {
    setData(props.data);
    setDataUrl(`/Request?MemoID=${props.data.memoID}`);
  }, [props.data]);
  const history = useHistory();
  const amount_label = "[Amount/day]";
  const { t } = useTranslation(["translation"]);

  useEffect(() => {
    const sanitizedUid = uuidv4().replace(/-/g, "").toUpperCase();
    const newUrl = `${sanitizedUid.toString()}`;
    setUrl(newUrl);
  }, []);

  useEffect(() => {
    if (props.currentMemoId === props.data.memoID) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [props.currentMemoId]);

  const formatDate = () => {
    let momentObj = moment(data.modifiedDate, "DD/MM/yyyy HH:mm:ss");

    return moment(momentObj).format(
      masterSetting?.FormatDate?.Value1.replaceAll("d", "D") ||
        "DD MMM yyyy , HH:mm"
    );
  };
  const resposeComment = (comment: any) => {
    props.onUpdate("approve", props.data.memoID, comment);
  };

  const delegateMemo = (data: any) => {
    if (data.isDelegated) {
      return (
        <Badge
          className="p-ml-2 worklist-badge"
          value={"Delegate"}
          style={{
            color: "white",
            background: "#20B2AA",
          }}
        />
      );
    }
  };

  const onApproveActionClick = async () => {
    const approvals = await GetApprovalsByMemoIDs([...[], data.memoID]).catch(
      (e) => {
        console.error(e);
        return [];
      }
    );
    if (approvals) {
      setLineApproval([...approvals]);
    }
    setIsCommentActive(true);
  };

  return (
    <motion.div className={`card-container ${isActive ? "-active" : ""}`}>
      <div
        className="card-content-container desktop"
        onClick={() => {
          let _requestor = data.requestor || {};
          props.setContent(data.memoID, data.status, props.index, _requestor);
          props.setOnDetailLoading(true);
        }}
      >
        <div className="card-body-content-container">
          <div className="running-number-container" style={{marginTop: "5px"}}>
            <Link className="text-form-running" to={dataUrl + "&WFID=" + url}>
              {data.documentNo}
            </Link>
            <p className="text-date">{formatDate()}</p>
          </div>
          <Space>
            {props.data?.MemoHistoryAmount > 0 && (
              <BadgeNotificate
                dataMemo={props.data}
                dataDetail={null}
                requestData={null}
                type="history"
              />
            )}
            {props.data?.MemoAttachFileAmount > 0 && (
              <BadgeNotificate
                dataMemo={props.data}
                dataDetail={null}
                requestData={null}
                type="attachment"
              />
            )}
            <p className="text-format">
              {data.amount == ".00" ? null : amount_label}
            </p>
          </Space>
        </div>
        <div className="text-subject-container">
          <span className="card-text-detail">{data.subject}</span>
          <div className="result-container">
            <p className="text-result">
              {data.amount == ".00" ? null : data.amount}
            </p>
          </div>
        </div>
        <div className="card-topic-and-status-container">
          <p
            className="text-form-type"
            style={{ justifyContent: "flex-start" }}
          >
            {data.templateName}
          </p>
          {/* delegate */}
          <span
            style={{
              display: "flex",
              justifyContent: "flex-end space-between",
              columnGap: "8px",
            }}
          >
            {delegateMemo(data)}
            <Badge
              className="p-mr-2 worklist-badge"
              value={t(data.status)}
              style={{
                color: "white",
                background:
                  data.status === "Wait for Approve"
                    ? "#282f6a"
                    : data.status === "Recall"
                    ? "#F8A51C"
                    : data.status === "Draft"
                    ? "#b4b4b4"
                    : data.status === "Completed"
                    ? "#28a745"
                    : data.status === "Rework"
                    ? "#F8A51C"
                    : data.status === "Cancelled"
                    ? "#dc3545"
                    : data.status === "Rejected"
                    ? "#dc3545"
                    : data.status === "Wait for Comment"
                    ? "#06BEE1"
                    : null,
              }}
            ></Badge>
          </span>
        </div>
      </div>

      <div className="card-footer-container desktop">
        <div className="list-aprroval-container">
          <div className="request-by-container">
            <p className="text-label">{t("Request By")}</p>
            <p className="text-name">
              {data.requestor !== null
                ? user.Lang === "EN"
                  ? data.requestor.nameEn
                  : data.requestor.nameTh
                : "-"}
            </p>
          </div>
          <FaChevronRight />
          <div className="waiting-for-container">
            <p className="text-label">{t("Waiting for")}</p>
            <p className="text-name">
              {data.waitingFor !== null 
                ? user.Lang === "EN"
                  ? data.waitingFor.nameEn
                  : data.waitingFor.nameTh
                : data.status==="Wait for Approve"?"Parallel Approver":"-"
                }
            </p>
          </div>
        </div>
        {props.taskGourp === "todo" && (
          <>
            {data.status === "Wait for Approve" && (
              <button
                className="approve-button"
                onClick={() => onApproveActionClick()}
              >
                {t("Approve")}
              </button>
            )}
          </>
        )}
      </div>

      <div
        className="card-content-container mobile"
        onClick={() => {
          const memoid = { MemoID: data.memoID };
          // history.push("/Request", memoid);
          history.push(`/Request?MemoID=${data.memoID}`, memoid);
        }}
      >
        <div className="card-body-content-container">
          <div className="running-number-container">
            <Link className="text-form-running" to={dataUrl + url}>
              {data.documentNo}
            </Link>
            <p className="text-date">{formatDate()}</p>
          </div>
          <div className="result-container">
            <Space>
              {props.data?.MemoHistoryAmount > 0 && (
                <BadgeNotificate
                  dataMemo={props.data}
                  dataDetail={null}
                  requestData={null}
                  type="history"
                />
              )}
              {props.data?.MemoAttachFileAmount > 0 && (
                <BadgeNotificate
                  dataMemo={props.data}
                  dataDetail={null}
                  requestData={null}
                  type="attachment"
                />
              )}
              <p className="text-format">
                {data.amount == ".00" ? null : amount_label}
              </p>
            </Space>
            <p className="text-result">
              {data.amount == ".00" ? null : data.amount}
            </p>
          </div>
        </div>
        <p className="card-text-detail">{data.subject}</p>
        <div className="card-topic-and-status-container">
          <p className="text-form-type" style={{marginTop: "20px"}}>{data.templateName}</p>
          <Badge
            className="p-mr-2 worklist-badge"
            value={data.status}
            style={{
              color: "white",
              marginTop: "20px",
              background:
                data.status === "Wait for Approve"
                  ? "#282f6a"
                  : data.status === "Recall"
                  ? "#F8A51C"
                  : data.status === "Draft"
                  ? "#b4b4b4"
                  : data.status === "Completed"
                  ? "#28a745"
                  : data.status === "Rework"
                  ? "#F8A51C"
                  : data.status === "Cancelled"
                  ? "#dc3545"
                  : data.status === "Rejected"
                  ? "#dc3545"
                  : null,
            }}
          ></Badge>
        </div>
      </div>
      <div className="card-footer-container mobile">
        <div className="list-aprroval-container">
          <div className="request-by-container">
            <p className="text-label">{t("Request By")}</p>
            <p className="text-name">
              {data.requestor !== null
                ? user.Lang === "EN"
                  ? data.requestor.nameEn
                  : data.requestor.nameTh
                : "-"}
            </p>
          </div>
          <FaChevronRight />
          <div className="waiting-for-container">
            <p className="text-label">{t("Waiting for")}</p>
            <p className="text-name">
              {data.waitingFor !== null
                ? user.Lang === "EN"
                  ? data.waitingFor.nameEn
                  : data.waitingFor.nameTh
                : data.status==="Wait for Approve"?"Parallel Approver":"-"}
            </p>
          </div>
        </div>
        {props.taskGourp === "todo" && (
          <>
            {data.status === "Wait for Approve" && (
              <button
                className="approve-button"
                onClick={() => onApproveActionClick()}
              >
                {t("Approve")}
              </button>
            )}
          </>
        )}
        {isCommentActive && (
          <CommentComponent
            buttonType={"approve"}
            commentStatus={isCommentActive}
            setCommentStatus={setIsCommentActive}
            require={false}
            onUpdate={resposeComment}
            pageName={"WorkList"}
            lineApproval={lineApproval}
            approvalSequence={data.currentApprovalLevel}
          />
        )}
      </div>
    </motion.div>
  );
};
